<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{data.indicator.indicator}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="ngbActiveModal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="container-fluid">
        <div class="table-responsive max-table-height">
            <table class="table table-bordered table-sm m-0">
                <thead  style="background-color: #5D6B99 !important; color: #FFFFFF !important;">
                    <tr>
                        <th>
                            Fecha de modificación
                        </th>
                        <th>
                            Resultado
                        </th>
                        <th>
                            Observacioens
                        </th>
                        <th>
                            Semana o mes
                        </th>
                        <th>
                            Realizado por
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let mesurement of mesurements">
                        <td>
                            {{ returnDateFormat(mesurement.createdAt) }}
                        </td>
                        <td>
                            {{ returnChangedFormat(mesurement.result) }}
                        </td>
                        <td>
                            {{ mesurement.observation }}
                        </td>
                        <td>
                            <span *ngIf="mesurement.weekNumber">S{{mesurement.weekNumber}}</span>
                            <span *ngIf="mesurement.monthNumber">M{{returnMonthFormat(mesurement.monthNumber)}}</span>
                        </td>
                        <td>
                            {{ mesurement.createdByName }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="modal-footer">
    <div class="btn-group w-100 mt-5" role="group">
        <button type="button" class="btn btn-secondary" (click)="ngbActiveModal.close()">
            <span>Cancelar</span>
        </button>
    </div>
</div>
